<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="transactionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="transactionModalLabel">Transaction Details</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive mt-4">
            <table class="table align-middle table-nowrap">
              <tbody>
              <tr>
                <td style="width: 30%">
                  <p class="mb-0">Car Plate Number</p>
                </td>
                <td style="width: 25%">
                  <h5 class="mb-0 text-uppercase">UAG 1235p</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="mb-0">Vehicle Category</p>
                </td>
                <td>
                  <h5 class="mb-0">Salon Car</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="mb-0">Payment Date</p>
                </td>
                <td>
                  <h5 class="mb-0">22 Apr 2022 06:54PM</h5>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="mb-0">San Diego</p>
                </td>
                <td>
                  <h5 class="mb-0">1,026</h5>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="mb-0 pb-0">Amount Paid</p>
                  <h3>UGX 2,000</h3>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="mb-2">Attended By<span class="text-primary"> Alex Sebeye</span></p>
                  <p class="mb-4">Toll taker's No. <span class="text-primary">0704549859</span></p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: "TransactionModal",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>